import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { ArchiveSurveyDialog } from 'modules/engagement_surveys/components/ArchiveSurveyDialog'

type Data = {
  surveyId: string
}

export const ArchiveSurveyActivity: ActivityComponent<Data> = ({ surveyId }) => {
  const { open, closeActivity } = useActivity()

  if (!open) return null

  return (
    <ArchiveSurveyDialog
      surveyId={Number(surveyId)}
      onSuccess={closeActivity}
      onCancel={closeActivity}
    />
  )
}
